import React from 'react';
import { Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FiMail } from 'react-icons/fi';
import type { DashboardInvitations } from '../types/dashboard';

interface Props {
  invitations: DashboardInvitations;
  invitesPath: string;
}

const OutgoingInvitationsCard: React.FC<Props> = ({ invitations, invitesPath }) => {
  const navigate = useNavigate();
  const total = invitations.pending + invitations.expired_pending;

  if (total === 0 && invitations.expiring_within_7_days === 0) {
    return null;
  }

  return (
    <section className="dashboard-administration-section mb-4">
      <header className="dashboard-work-queue-section__header mb-2">
        <h2 className="dashboard-work-queue-section__title h6 mb-0">Administration</h2>
      </header>
      <Card
        className="ntcog-card dashboard-section-card dashboard-stat-card--clickable"
        role="button"
        onClick={() => navigate(invitesPath)}
      >
        <Card.Body className="d-flex align-items-center gap-3">
          <span className="dashboard-stat-card__icon dashboard-stat-card__icon--warning">
            <FiMail size={20} />
          </span>
          <div>
            <div className="dashboard-stat-card__value">{total}</div>
            <div className="dashboard-stat-card__label">Outgoing invitations</div>
            <small className="text-muted d-block">
              Pending acceptance by invitee
            </small>
            {invitations.pending > 0 && (
              <small className="text-muted d-block">{invitations.pending} awaiting acceptance</small>
            )}
            {invitations.expired_pending > 0 && (
              <small className="text-warning d-block">
                {invitations.expired_pending} expired — resend available
              </small>
            )}
            {invitations.expiring_within_7_days > 0 && (
              <small className="text-warning d-block">
                {invitations.expiring_within_7_days} expiring within 7 days
              </small>
            )}
          </div>
        </Card.Body>
      </Card>
    </section>
  );
};

export default OutgoingInvitationsCard;
